export default __webpack_public_path__ + "static/media/produk 6.d15d0b21.png";